module.exports = __webpack_public_path__ + "img/imgCita.4df82c04.jpg";